import React, { useContext } from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faColumns, faUserPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, CustomizableDashboard, Tools,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { UserModel } from '@models/types'

import type { PageContextPayload } from '@sections/Admin/packs/Dashboard/screens/Overview'

import styles from './styles.module.scss'

interface ContentSidebarProps {
  callbacks: {
    customizeDashboard: () => void,
  },
  currentUser: UserModel,
  draggablePlaceholder: object,
  id: string,
  isDraggingOver: boolean,
  modules: { key: string, moduleId: string }[],
}

const ContentSidebar = React.forwardRef((props: ContentSidebarProps, ref) => {
  const {
    callbacks: { customizeDashboard },
    currentUser,
    draggablePlaceholder,
    id,
    isDraggingOver,
    modules,
  } = props

  // @ts-expect-error TS2345
  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const { callbacks: { showBulkAssignUserTasksModal } } = pageContext

  return (
    <Box
      className={classnames(styles.root, isDraggingOver ? styles.draggingOver : null)}
      flexDirection="column"
      width={['100%', '100%', '375px']}
      paddingTop="large"
    >
      <Tools>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faUserPlus} />}
          onClick={() => showBulkAssignUserTasksModal({ user: currentUser })}
          marginBottom="medium"
          size="medium"
        >
          Assign Tasks
        </Button>

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faColumns} />}
          onClick={customizeDashboard}
          size="medium"
        >
          Customise Dashboard
        </Button>
      </Tools>

      {/*
       // @ts-expect-error TS2322 */}
      <div ref={ref} style={{ flexGrow: 1, minHeight: '100vh' }}>
        {/*
         // @ts-expect-error TS2786 */}
        {modules && <CustomizableDashboard.ModuleRenderer modules={modules} parentId={id} />}
        {draggablePlaceholder}
      </div>
    </Box>
  )
})

export default ContentSidebar
